import { sortBy } from 'lodash';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import parseDatabaseValue from 'utilities/parseDatabaseValue';
import { SsBaseReverseParserProps } from 'utilities/ssBaseReverseParser/ssBaseReverseParser.props';

const ssBaseReverseParser = ({ cells, columns, allowEmptyValues, rowConfig, checkPairCells, fieldAttributes }: SsBaseReverseParserProps) => {
  const sortedColumns = sortBy(columns, ['order']);
  const alphabet = alphabetGenerator([], sortedColumns.length);

  sortedColumns.forEach((column, columnIndex) => {
    const columnLegend = alphabet[columnIndex];

    // copy original values
    let tmpColumn = column ;

    // replace updated values
    rowConfig.forEach((cell, cellIndex) => {
      const key = columnLegend + (cellIndex + 1);
      const defaultValue = cell.defaultValue ?? null;
      const type = cell.dbType ?? null;
      const format = cell.format ?? null;
      const value = cells[key] ? cells[key].value : defaultValue;
      const { gridType } = cell;
      const decimalPlaces = fieldAttributes[cell.alias]?.decimal_places;

      if (cell.alias && cells[key]) {
        tmpColumn[cell.alias] =  parseDatabaseValue({
          type,
          value,
          format,
          allowEmptyValues,
          gridType,
          decimalPlaces,
        })
      }
      if (checkPairCells) {
        tmpColumn = checkPairCells(cell, key, tmpColumn);
      }
    });
  });

  return columns;
};

export default ssBaseReverseParser;
